import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_add_event_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body flex-center" }
const _hoisted_8 = { class: "modal-footer flex-center" }
const _hoisted_9 = {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_add_event_cancel",
  class: "btn btn-light me-3"
}
const _hoisted_10 = ["data-kt-indicator", "disabled"]
const _hoisted_11 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_12 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_13 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ref, reactive } from "vue";
import { TopicTypes } from "@/core/types/TopicTypes";
import GlobalService from "../../../services/TenantGlobalService";
import type { FormRules } from "element-plus";
import { hideModal, showModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEmailTemplate',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(true);
const submited = ref(false);

const createEmailTemplateModalRef = ref<null | HTMLElement>(null);



const detailForm = ref({
  title: "",
  type: TopicTypes.Email,
  language: "en-us",
  content: "content",
  author: "system",
  effectiveFrom: "",
  effectiveTo: "",
});

const emailFormRules = reactive<FormRules>({
  title: [{ required: true, message: "Please input the email template key" }],
});

const createEmailTemplate = async () => {
  submited.value = true;
  await GlobalService.createEmailTemplate(detailForm.value);
  emits("eventSubmit");
  submited.value = false;
  hide();
};

const show = () => {
  // initialize topic selectins list by TopicType enum
  detailForm.value = {
    title: "",
    type: TopicTypes.Email,
    language: "en-us",
    content: "content",
    author: "system",
    effectiveFrom: "",
    effectiveTo: "",
  };
  showModal(createEmailTemplateModalRef.value);
  isLoading.value = false;
};

const hide = () => {
  hideModal(createEmailTemplateModalRef.value);
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "createEmailTemplateModalRef",
    ref: createEmailTemplateModalRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          class: "form fv-plugins-bootstrap5 fv-plugins-framework",
          id: "kt_modal_add_event_form",
          onSubmit: _withModifiers(createEmailTemplate, ["prevent"]),
          model: detailForm.value,
          rules: emailFormRules,
          ref: "ruleFormRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.addNewEmailTemplate")), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.title'),
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: detailForm.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailForm.value.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t("status.cancel")), 1),
              _createElementVNode("button", {
                "data-kt-indicator": isLoading.value ? 'on' : null,
                class: "btn btn-lg btn-primary",
                type: "submit",
                disabled: isLoading.value
              }, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.submit")) + " ", 1),
                      _createElementVNode("span", _hoisted_12, [
                        _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.$t("title.inProgress")) + " ", 1),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_10)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "model", "rules"])
      ])
    ])
  ], 512))
}
}

})